<template>
  <v-card
    elevation="3"
  >
    <v-card-title class="d-flex justify-space-between align-start mb-0 pb-3">
      <div>
        <h2>Clients list</h2>
        <v-breadcrumbs
          v-if="false"
          class="mb-0 pb-0 ml-0 pl-0 pt-1"
          :items="breadcrumbs"
        />
      </div>
    </v-card-title>
    <v-card-text>
      <v-row class="mt-2">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="players"
            disable-pagination
            disable-filtering
            disable-sort
            hide-default-footer
            no-data-text="Not found"
            loading-text="Loading..."
            :loading="loading.init"
          >
            <template #item.name="{ item }">
              <router-link
                :to="`/clients/details/${item.id}`"
                class="black--text"
              >
                {{ item.name }}
              </router-link>
            </template>
            <template #item.status="{ item }">
              <client-status :value="item.activity" />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-pagination
            v-model="pagination.page"
            :length="Math.ceil(pagination.count/pagination.limit)"
            color="blue-grey darken-4 white--text"
            total-visible="8"
            @input="changePage"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ClientStatus from '@/components/app/statuses/ClientStatus.vue';
import clientsAPI from '../../api/clients';

export default {
  components: {
    ClientStatus,
  },

  data: () => ({
    loading: {
      init: false,
    },

    filtered: false,

    pagination: {
      page: 1,
      count: 10,
      limit: 10,
    },

    filter: {
      email: '',
    },
    showFilter: false,
    breadcrumbs: [
      { text: 'Dashboard', to: '/organizations' },
      { text: 'Clients list', disabled: true },
    ],
    headers: [
      { text: '#', value: 'id' },
      { text: 'Activity', value: 'status', align: 'center' },
      { text: 'Name', value: 'name' },
    ],
    players: [],
  }),

  created() {
    this.init();
  },

  methods: {

    init() {
      this.loading.init = true;
      clientsAPI.list({
        ...this.filter,
        page: this.pagination.page,
        limit: this.pagination.limit,
      })
        .then((response) => {
          if (response.data.success) {
            this.players = response.data.data.players;
            this.pagination.count = response.data.data.count;
            this.filtered = response.data.data.filtered;
          }
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    changePage(page) {
      this.pagination.page = page;
      this.init();
    },

    resetFilter() {
      this.showFilter = false;
      this.filter = {
        email: '',
      };
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
  .filter {
    background: var(--color-filter-bg);
  }
</style>
